import { Field, useFormikContext } from "formik";
import React, { FC } from "react";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { useLocale } from "../../../contexts/localeContext";
import { requiredValidation } from "../../../utilities/Validation";
import Label from "../../label/label";
import TimeField from "../../timeField/timeField";

interface TimeStepProps {
    onBack: (event: any) => void;
    onNext: (event: any) => void;
    filterModalTrigger: string;
}

const TimeStep: FC<TimeStepProps> = ({ onBack, onNext, filterModalTrigger }) => {
    const { translate } = useLocale();
    const { errors, values } = useFormikContext<any>();

    return <div className="flex flex-col pt-1 pr-3 h-full relative">
        <span className={`mb-3 text-portal-blue-primary text-xl font-semibold`}>
            {translate.byKey(TranslationKeys.selectTimeFilter)}
        </span>

        <div className="mt-1">
            <div className="flex flex-row justify-between" id='timeLabel'>
                <Label
                    required
                    htmlFor="time"
                    className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.time)}:</Label>
                {errors.time ? <span className='text-red-600 text-xs pr-6'>{errors.time}</span> : null}
            </div>
            <div className="flex flex-row justify-between w-64" id='timeId'>
                <Field
                    valueName="time"
                    name="time"
                    placeholder={"--:--"}
                    component={TimeField}
                    validate={(value) => requiredValidation(value, translate)} />
            </div>
        </div>

        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            {!filterModalTrigger ?
                <div className="flex flex-row mt-4">
                    <button
                        className={`secondary secondary-inverse py-1 px-5`}
                        type="button"
                        onClick={onBack}>{translate.byKey(TranslationKeys.back)}</button>
                </div> : null}
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className={`py-1 px-5 secondary ${values.time ? "secondary-enabled" : "secondary-disabled cursor-not-allowed"}`}
                    type='button'
                    disabled={!!!values.time}
                    onClick={(event) => {
                        if (values.time) {
                            onNext(event)
                        }
                    }}>{translate.byKey(TranslationKeys.next)}</button>
            </div>
        </div>
    </div>
}

export default TimeStep;